import { useRef } from "react";
import { SeoHead } from "@/components/seo/SeoHead";
import { generatePageMetadata } from "@/lib/seo/metadata";
import { getStructuredData } from "@/lib/seo/structured-data";
import { PageContainer } from "@/shared/layout/PageContainer";
import { DesktopLanding } from "@/features/landing/components/desktop/DesktopLanding";
import { useLandingNavigation } from "@/features/landing/components/useLandingNavigation";

const landingPageMetadata = generatePageMetadata({
  path: "/",
});
const landingStructuredData = getStructuredData("home");

const LandingPage = () => {
  const mainRef = useRef<HTMLElement>(null);
  useLandingNavigation(mainRef);
  return (
    <>
      <SeoHead metadata={landingPageMetadata} structuredData={landingStructuredData} />
      <main
        ref={mainRef}
        tabIndex={-1}
        className="flex min-h-screen w-full flex-col items-center bg-background outline-none"
      >
        <PageContainer>
          <DesktopLanding baseAnalyticsElementId="landing-desktop:page" />
        </PageContainer>
      </main>
    </>
  );
};

export default LandingPage;
